import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import { cva, VariantProps } from 'class-variance-authority';
import { ReactNode } from 'react';

export const labeledCheckboxVariants = cva('', {
  variants: {
    variant: {
      default: '',
      bordered: `data-[state=checked]:border-black data-[state=checked]:bg-black data-[state=checked]:text-white dark:data-[state=checked]:border-white dark:data-[state=checked]:bg-white dark:data-[state=checked]:text-black`,
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});
export const labeledCheckboxLabelVariants = cva('', {
  variants: {
    variant: {
      default: '',
      bordered: cn(
        `hover:bg-accent/50 flex items-start gap-3 rounded-lg border p-3 has-[[aria-checked=true]]:border-black has-[[aria-checked=true]]:bg-gray-50 dark:has-[[aria-checked=true]]:border-white dark:has-[[aria-checked=true]]:bg-gray-900`,
      ),
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

interface LabeledCheckboxProps
  extends React.ComponentProps<typeof Checkbox>,
    VariantProps<typeof labeledCheckboxVariants> {
  label: ReactNode;
  subLabel?: ReactNode;
}
export function LabeledCheckbox({
  variant,
  label,
  subLabel,
  ...props
}: LabeledCheckboxProps) {
  return (
    <Label className={cn(labeledCheckboxLabelVariants({ variant }))}>
      <Checkbox
        className={cn(labeledCheckboxVariants({ variant }))}
        {...props}
      ></Checkbox>
      <span className="grid">
        <span className="text-sm">{label}</span>
        {subLabel && (
          <span className="text-muted-foreground text-sm">{subLabel}</span>
        )}
      </span>
    </Label>
  );
}
